import styled from 'styled-components';
import { Input } from 'reactstrap';

export default styled(Input).attrs({ type: 'radio' })`
  display: none;
`;
